import script from "./ProgramsInspireView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramsInspireView.vue?vue&type=script&setup=true&lang=js"

import "./ProgramsInspireView.vue?vue&type=style&index=0&id=7637d768&lang=css"

const __exports__ = script;

export default __exports__